import { pxToRem } from "@/util";
import { Box, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import Image from "next/image";
import { AppColors } from "@/assets/colors";
export default function Header() {
  const { classes } = styles();
  return (
    <Box className={`${classes.container} `}>
      <Box className={`${classes.imgCont}`}>
        <Image
          src="/images/dashboard/blog/blogheader.svg"
          alt="discover"
          objectFit="cover"
          fill={true}
        />
      </Box>
      <Box className={`${classes.detCont}`}>
        <Typography className={`${classes.head}`}>
          Blogs and Tips from AREL Team{" "}
        </Typography>
        <Typography className={`${classes.desc}`}>
          Explore expert articles, market trends, and real estate tips to guide
          your next investment with confidence.
        </Typography>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: pxToRem(377),
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(4),
  },
  imgCont: {
    position: "absolute",
    width: "100%",
    height: "100%",
    flex: 1,
    zIndex: -1,
  },
  detCont: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    width: "70%",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "90%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  head: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(60),
    color: theme.colors.white,
    textAlign: "center",
    lineHeight: "120%",
    width: "100%",

    [theme.breakpoints.down("md")]: {
      fontSize: pxToRem(42),
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(32),
    },
  },
  desc: {
    fontWeight: 400,
    fontSize: pxToRem(20),
    textAlign: "center",
    color: AppColors.neutral["90"],
    lineHeight: "160%",
    width: "80%",
    [theme.breakpoints.down("md")]: {
      fontSize: pxToRem(18),
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: pxToRem(16),
    },
  },
}));
